(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-results/assets/javascripts/models/match.js') >= 0) return;  svs.modules.push('/modules/game-results/assets/javascripts/models/match.js');

'use strict';

svs.game_results.models.Match = Backbone.Model.extend({
  defaults: {
    latestUpdate: '',
    miniStatIsOpen: false,
    isCancelled: false,
    hasStarted: false,
    isLive: false,
    roundIsLive: true,
    hasChangedResult: false
  },
  initialize(attributes, options) {
    var _match$sport, _match$league$sport;
    const forecast = options.modelFromView.get('forecast');
    const drawResult = options.modelFromView.get('result');
    const eventNumber = this.get('eventNumber');
    const matchIndex = this.get('eventNumber') - 1;
    const product = options.modelFromView.get('product');
    const sportTypes = svs.components.sport.sportTypes.SportTypes;
    const match = this.get('match');
    const currentSporType = match === null || match === void 0 || (_match$sport = match.sport) === null || _match$sport === void 0 ? void 0 : _match$sport.type;
    const challengeEventTypeIds = svs.game_results.constants.challengeEventTypeIds;
    const getLabelForSportEvent = svs.components.poolBetting.utils.getLabelForSportEvent;
    let formattedEventDescription = "".concat(match === null || match === void 0 ? void 0 : match.participants[0].mediumName, " - ").concat(match === null || match === void 0 ? void 0 : match.participants[1].mediumName);
    if (currentSporType === sportTypes.Trotting || this.get('eventTypeId') === challengeEventTypeIds.EVENT_H2H) {
      formattedEventDescription = this.get('eventDescription');
    }
    this.set('formattedEventDescription', formattedEventDescription, {
      silent: true
    });
    this.set('product', product, {
      silent: true
    });
    this.set('showAsCancelled', product === 'challenge' || product === 'bomben', {
      silent: true
    });
    if (options.modelFromView.get('isBeforeStart')) {
      this.set('roundIsBeforeStart', true);
    }
    if (match) {
      match.league = match.league || {};
      match.league.sport = match.league.sport || {};
    }
    if (match && _.isUndefined(match.league.sport.id)) {
      if (match.sport && match.sport.id) {
        match.league.sport.type = match.sport.type;
      } else if (this.get('product').toLowerCase() !== 'challenge') {
        match.league.sport.type = svs.components.sport.sportTypes.SportTypes.Soccer;
      }
    }
    const matchStatusText = svs.components.sportinfo.sportConfig.helpers.getStatusText({
      sportEventStatus: match === null || match === void 0 ? void 0 : match.sportEventStatus,
      sportType: match === null || match === void 0 || (_match$league$sport = match.league.sport) === null || _match$league$sport === void 0 ? void 0 : _match$league$sport.type,
      matchState: svs.components.sportinfo.common.matchState.getSportInfoMatchState(match === null || match === void 0 ? void 0 : match.sportEventStatus),
      statusTime: match === null || match === void 0 ? void 0 : match.statusTime,
      matchStart: match === null || match === void 0 ? void 0 : match.matchStart,
      statusTextLength: 'short'
    }).matchStatusText;
    let label = getLabelForSportEvent({
      eventResult: undefined,
      matchStatus: {
        isOngoing: Boolean(this.hasStarted() && !this.isFinalized()),
        isFinished: this.isFinalized(),
        matchStatusText,
        isCancelled: this.isCancelled()
      },
      sportEventStatus: match === null || match === void 0 ? void 0 : match.sportEventStatus
    });
    if (drawResult && !options.modelFromView.get('roundIsLive')) {
      this.set('result', drawResult.events[matchIndex]);
      this.set('drawCancelled', drawResult.cancelled);
      this.set('roundIsLive', false);
      label = getLabelForSportEvent({
        eventResult: "".concat(drawResult.events[matchIndex].outcome.home, " - ").concat(drawResult.events[matchIndex].outcome.away),
        matchStatus: {
          isOngoing: Boolean(this.hasStarted() && !this.isFinalized()),
          isFinished: this.isFinalized(),
          matchStatusText,
          isCancelled: this.isCancelled()
        },
        sportEventStatus: match === null || match === void 0 ? void 0 : match.sportEventStatus
      });
    }
    if (forecast) {
      const change = _.findWhere(forecast.changes, {
        evnum: eventNumber
      });
      if (change) {
        this.set('latestUpdate', change.team);
      }
      this.set('forecastResult', forecast.drawResults[matchIndex]);
      this.set('drawCancelled', forecast.cancelled);
      this.set('changes', forecast.changes);
      this.set('drawState', forecast.drawState);
      label = getLabelForSportEvent({
        eventResult: "".concat(forecast.drawResults[matchIndex].home, " - ").concat(forecast.drawResults[matchIndex].away),
        matchStatus: {
          isOngoing: Boolean(this.hasStarted() && !this.isFinalized()),
          isFinished: this.isFinalized(),
          matchStatusText,
          isCancelled: this.isCancelled()
        },
        sportEventStatus: match === null || match === void 0 ? void 0 : match.sportEventStatus
      });
    }
    this.set('ariaLabel', label);
    this.updateStatuses();
    this.startClock();
  },
  setSportInLeague() {
    const match = this.get('match') || {};
    match.league = match.league || {};
    match.league.sport = match.league.sport || {};
    if (_.isUndefined(match.league.sport.id)) {
      if (match.sport && match.sport.id) {
        match.league.sport.id = match.sport.id;
        match.league.sport.name = match.sport.name;
        match.league.sport.type = match.sport.type;
      } else if (this.get('product').toLowerCase() === 'powerplay') {
        match.league.sport.id = 1000003;
        match.league.sport.name = 'Ishockey';
        match.league.sport.type = svs.components.sport.sportTypes.SportTypes.Hockey;
      } else if (this.get('product').toLowerCase() !== 'challenge') {
        match.league.sport.id = 1000002;
        match.league.sport.name = 'Fotboll';
        match.league.sport.type = svs.components.sport.sportTypes.SportTypes.Soccer;
      }
    }
  },
  isCancelled() {
    const forecastResult = this.get('forecastResult');
    const result = this.get('result');
    if (forecastResult && forecastResult.cancelled === 1) {
      return true;
    }
    if (result && result.cancelled) {
      return true;
    }
    return false;
  },
  updateMatch(match) {
    this.set('match', match, {
      silent: true
    });
    this.updateStatuses();
  },
  updateStatuses() {
    const match = this.get('match');
    if (match) {
      var _match$sport2;
      this.setSportInLeague();
      const matchListText = svs.components.sportinfo.sportConfig.helpers.getStatusText({
        sportEventStatus: match.sportEventStatus,
        sportType: match.league.sport.type,
        matchState: svs.components.sportinfo.common.matchState.getSportInfoMatchState(match.sportEventStatus),
        statusTime: match.statusTime,
        matchStart: match.matchStart,
        statusTextLength: 'short'
      }).matchStatusText;
      match.matchListText = matchListText;
      const hasStarted = this.hasStarted();
      const isCancelled = this.isCancelled();
      const hasEnded = this.hasEnded(match.sportEventStatus);
      const isLive = hasStarted && !hasEnded && !isCancelled;
      this.set('hasStarted', hasStarted || isCancelled);
      this.set('isCancelled', isCancelled);
      this.set('isLive', isLive);
      this.set('hasEnded', hasEnded);
      this.set('startTimeHasSurpassed', this.startTimeHasSurpassed());
      this.set('isTrotting', match.sport && match.sport.type === svs.components.sport.sportTypes.SportTypes.Trotting);
      const hasSimpleSportStatus = [svs.components.sport.sportTypes.SportTypes.Trotting].includes(match === null || match === void 0 || (_match$sport2 = match.sport) === null || _match$sport2 === void 0 ? void 0 : _match$sport2.type);
      this.set('hasSimpleSportStatus', hasSimpleSportStatus);
      let resultTextAccessibility;
      if (isLive && this.get('hasChangedResult') && this.get('forecastResult')) {
        resultTextAccessibility = svs.components.poolBetting.ariaUtils.composeResultUpdateText({
          eventTypeId: this.get('product') === 'bomben' ? svs.game_results.constants.eventTypeIds.RESULT : this.get('eventTypeId'),
          eventNumber: this.get('eventNumber'),
          eventDescription: this.get('formattedEventDescription'),
          numberOfGoalsHomeTeam: this.get('forecastResult').home,
          numberOfGoalsAwayTeam: this.get('forecastResult').away
        });
        this.set('resultTextAccessibility', resultTextAccessibility);
      }
      this.trigger('timeChanged', this);
      this.trigger('statusUpdated', this);
    }
  },
  startTimeHasSurpassed() {
    if (this.get('hasStarted')) {
      return true;
    }
    const match = this.get('match');
    if (!match) {
      return false;
    }
    const currentTime = new Date();
    const matchStartTime = new Date(match.matchStart);
    const startTimeDiff = dateFns.differenceInMinutes(currentTime, matchStartTime);
    if (startTimeDiff >= 0) {
      return true;
    }
    return false;
  },
  hasStarted() {
    const match = this.get('match');
    if (!match) {
      return;
    }
    const forecastResult = this.get('forecastResult');
    const goalIsScored = forecastResult && (forecastResult.home > 0 || forecastResult.away > 0);
    return !svs.components.sportinfo.common.matchState.getIsNotStarted(match.sportEventStatus) && (svs.components.sportinfo.common.matchState.getIsFinishedNotCancelled(match.sportEventStatus) || svs.components.sportinfo.common.matchState.getIsOngoing(match.sportEventStatus)) || goalIsScored || this.hasEnded(match.sportEventStatus);
  },
  hasEnded(sportEventStatus) {
    return svs.components.sportinfo.common.matchState.getIsFinishedNotCancelled(sportEventStatus) || this.isFinalized();
  },
  isFinalized() {
    const result = this.get('forecastResult');
    if (!result) {
      return false;
    }
    return result.matchResultState >= svs.game_results.constants.matchResultState.FINAL;
  },
  startClock() {
    if (this.timeInterval === undefined) {
      this.timeInterval = setInterval(() => {
        window.requestIdleCallback(() => {
          this.updateStatuses();
        });
      }, 10000);
    }
  },
  toggleMiniStatIsVisible() {
    this.set('miniStatIsOpen', !this.get('miniStatIsOpen'), {
      silent: true
    });
  }
});

 })(window);